import React from 'react';

const Activity: React.FC = () => {
  return (
    <div>
      <h1>Activity</h1>
      <p>This is the Activity component.</p>
    </div>
  );
};

export default Activity;
